import axios from 'axios'
import authHeader from './auth-header'
// import moment from 'moment'

class NegociaService {
  getPoliticas () {
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/politicas/0`, { headers: authHeader() })
  }

  getPolitica ( idPolitica ) {
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/politica/${idPolitica}`, { headers: authHeader() })
  }

  getCampanhas ( ) {
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/campanhas/0`, { headers: authHeader() })
  }

  getAlunosFiltrados (options) {
    var { siglaUnidade, periodoLetivo, idCurso, serie, idTurma } = options

    idCurso = idCurso ?? 0
    serie = serie ?? 0
    idTurma = idTurma ?? 0

    return axios.get(process.env.VUE_APP_API_URL + `negocieja/publicos/filtrar/${siglaUnidade}/${periodoLetivo}/${idCurso}/${serie}/${idTurma}`,{ headers: authHeader() });
  }

  getCampanha( idCampanha ) {
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/campanha/${idCampanha}`, { headers: authHeader() })
  }

  updateCampanha(idNegocieJaCampanha, data) {
    return axios.put(process.env.VUE_APP_API_URL + `negocieja/campanha/${idNegocieJaCampanha}`, data, { headers: authHeader() });
  }

  updatePolitica(idNegocieJaPolitica, data) {
    return axios.put(process.env.VUE_APP_API_URL + `negocieja/politica/${idNegocieJaPolitica}`, data, { headers: authHeader() });
  }
 
  createCampanha ( dadosCampanha ) {
    return axios.post(process.env.VUE_APP_API_URL + `negocieja/campanha`, dadosCampanha, { headers: authHeader() })
  }

  createPolitica ( dadosPolitica ) {
    return axios.post(process.env.VUE_APP_API_URL + `negocieja/politica`, dadosPolitica, { headers: authHeader() })
  }

  getPublicos (){
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/publicos/0`, { headers: authHeader() })
  }

  getPagamentos (){
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/formaspagamento/0`, { headers: authHeader() })
  }

  createPublico(payload) {
  return axios.post(process.env.VUE_APP_API_URL + `negocieja/publico`, payload, { headers: authHeader() });
  }

  createPagamentos (payload){
    return axios.post(process.env.VUE_APP_API_URL + `negocieja/formapagamento`, payload, { headers: authHeader() })
  }

  getBloqueios (){
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/tipos/bloqueio/matriculas`, { headers: authHeader() })
  }
}

export default new NegociaService()